import { MutationTree } from 'vuex';
import { State } from '@/store/modules/cloud/integrations/integrations.store';

const mutations: MutationTree<State> = {
  setAllVendors(state: State, data: any) {
    state.available = data;
  },
  setInstalledVendors(state: State, data: any) {
    state.installed = data;
  },
  setAllProjects(state: State, data: any) {
    state.projects = data;
  },
};

export default mutations;
